import React, {useRef} from 'react'
import ScrollBar from 'react-perfect-scrollbar'
import tw from 'tailwind-styled-components'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {WithResizeObserver} from '@components/sticker/sticker-panel/resize-observer'

interface Props {
  children?: React.ReactNode
  title: React.ReactNode
  childrenClassName?: string
  topZero?: boolean
  scrollable?: boolean
}

const TwChildren = tw.div<{$topZero?: boolean}>`
  ${p => (p.$topZero ? 'top-0' : 'top-85')}
  absolute
  bottom-0
  w-full
  pl-32
  pr-24
`

const TwScrollableChildren = tw(WithPerfectScrollbar)<{$topZero?: boolean}>`
  ${p => (p.$topZero ? 'top-0' : 'top-85')}
  overflow-auto
  absolute
  bottom-0
  w-full
  pl-32
  pr-24
`

export const TwPageHeader = tw.div`
  relative
  z-10
  pl-16
  bg-panel-background-default
  [backdrop-filter:blur(40px)]
  shadow-border-b-1
  shadow-panel-line-base
`

export const PageComponent = ({
  title,
  children,
  childrenClassName,
  topZero,
  scrollable = false
}: Props) => {
  const scrollContainer = useRef<ScrollBar>()
  const onResizeHeight = () => {
    if (scrollContainer.current) {
      scrollContainer.current.updateScroll()
    }
  }

  return (
    <>
      <TwPageHeader>{title}</TwPageHeader>
      {scrollable ? (
        <TwScrollableChildren
          className={childrenClassName}
          ref={scrollContainer}
          scrollDirection="xy"
          $topZero={topZero}
        >
          <WithResizeObserver type="h" callback={onResizeHeight}>
            <>{children}</>
          </WithResizeObserver>
        </TwScrollableChildren>
      ) : (
        <TwChildren className={childrenClassName} $topZero={topZero}>
          {children}
        </TwChildren>
      )}
    </>
  )
}
